/* Vortex Corner — lecteur de l'animation du logo (variante « Aspiration »).
   Les tracés sont précalculés dans vx-logo-frames.js (généré par vx-logo-anim-gen.js) : la lecture ne fait
   que changer des attributs d, aucun calcul géométrique pendant l'animation.
   Shopify : assets/vx-logo-frames.js (async) + assets/vx-logo-anim.js, avant vx-motion.js.
   Usage : <span data-vx-logo-anim> contenant le logo statique de secours ; window.VXLogo.play(el, { duration }) */
(function () {
  if (window.VXLogo) return;
  var d = document, NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var LS = 0.66, S = 1280 * LS, CX = 960, CY = 480 - (638 - 556) * LS;
  var FX = 0.721, FT = -0.4266, FB = 0.555, FR = 0.098, FC1 = -0.286, FC2 = 0.288;
  var fx = function (x) { return Math.round(CX + S * x); }, fy = function (y) { return Math.round(CY + S * y); }, fr = Math.round(S * FR);
  var FRAME = [
    'M' + fx(-FX) + ' ' + fy(FC1) + 'V' + fy(FT + FR) + 'A' + fr + ' ' + fr + ' 0 0 1 ' + fx(-FX + FR) + ' ' + fy(FT) + 'H' + fx(FX - FR) + 'A' + fr + ' ' + fr + ' 0 0 1 ' + fx(FX) + ' ' + fy(FT + FR) + 'V' + fy(FC1),
    'M' + fx(-FX) + ' ' + fy(FC2) + 'V' + fy(FB - FR) + 'A' + fr + ' ' + fr + ' 0 0 0 ' + fx(-FX + FR) + ' ' + fy(FB) + 'H' + fx(FX - FR) + 'A' + fr + ' ' + fr + ' 0 0 0 ' + fx(FX) + ' ' + fy(FB - FR) + 'V' + fy(FC2)
  ];
  var PAD = 12, VX = CX - S - PAD, VW = 2 * (S + PAD), VY = CY + S * FT - PAD, VH = VW * 2860 / 5774;
  var E = {
    outCubic: function (t) { return 1 - Math.pow(1 - t, 3); },
    inOutCubic: function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; },
    inOutQuart: function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2; }
  };
  function tw(T, a, b, from, to, ease) { if (T <= a) return from; if (T >= b) return to; return from + (to - from) * ease((T - a) / (b - a)); }
  // Scènes : Formation 0–1,8 s · Aspiration 1,8–4,8 s · Logo 4,8–6 s
  var ASP = 1.8, L = 4.8, TOTAL = 6;

  function frameAt(F, T) {
    var ringOp = tw(T, 0.8, ASP - 0.2, 0, 1, E.outCubic), frame = tw(T, L - 0.5, L + 0.5, 0, 1, E.inOutCubic), stat, rings;
    if (T < ASP) { var e = F.early[Math.min(F.n - 1, Math.floor(T / ASP * F.n))]; stat = e[0]; rings = e[1]; }
    else {
      var flow = tw(T, 0.8, L + 0.3, 0, 9, E.inOutQuart), ph = ((flow % 1) + 1) % 1, P = F.phases.length;
      stat = F.full; rings = F.phases[Math.round(ph * P) % P];
    }
    return { stat: stat, rings: rings, ringOp: ringOp, frame: frame };
  }
  function mount(el) {
    if (el.__vx) return el.__vx;
    var svg = d.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', VX.toFixed(1) + ' ' + VY.toFixed(1) + ' ' + VW.toFixed(1) + ' ' + VH.toFixed(1));
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;overflow:visible;display:block';
    var mk = function () { var p = d.createElementNS(NS, 'path'); p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', el.getAttribute('data-vx-stroke') || '1.15'); p.setAttribute('vector-effect', 'non-scaling-stroke'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round'); svg.appendChild(p); return p; };
    var st = mk(), rg = mk(), fr1 = mk(), fr2 = mk();
    [fr1, fr2].forEach(function (p, i) { p.setAttribute('d', FRAME[i]); p.setAttribute('pathLength', '1'); p.setAttribute('stroke-dasharray', '1 1'); p.setAttribute('stroke-linecap', 'butt'); });
    el.appendChild(svg);
    return (el.__vx = { st: st, rg: rg, fr: [fr1, fr2], raf: 0, last: {} });
  }
  function draw(v, F, T) {
    var f = frameAt(F, T), L0 = v.last;
    if (f.stat !== L0.stat) v.st.setAttribute('d', f.stat || 'M0 0');
    if (f.rings !== L0.rings) v.rg.setAttribute('d', f.rings || 'M0 0');
    v.rg.setAttribute('opacity', f.ringOp.toFixed(3));
    var off = String(1 - f.frame), op = String(Math.min(1, f.frame * 3));
    v.fr.forEach(function (p) { p.setAttribute('stroke-dashoffset', off); p.setAttribute('opacity', op); });
    v.last = f;
  }
  function whenFrames(cb) {
    if (window.VX_LOGO_FRAMES) return cb(window.VX_LOGO_FRAMES);
    var n = 0, id = setInterval(function () { if (window.VX_LOGO_FRAMES) { clearInterval(id); cb(window.VX_LOGO_FRAMES); } else if (++n > 200) clearInterval(id); }, 50);
  }

  window.VXLogo = {
    // Joue l'animation (durée totale en secondes ; 6 = version complète). La dernière image reste : c'est le logo.
    // Tant que les tracés ne sont pas chargés, le logo statique de secours reste affiché.
    play: function (el, opts) {
      if (!el) return;
      opts = opts || {};
      whenFrames(function (F) {
        var v = mount(el); el.setAttribute('data-vx-logo-live', '');
        cancelAnimationFrame(v.raf);
        if (reduce.matches || opts.duration === 0) { draw(v, F, TOTAL); return; }
        var dur = (opts.duration || TOTAL) * 1000, t0 = performance.now();
        var tick = function (now) {
          var k = Math.max(0, Math.min(1, (now - t0) / dur)); // l'horodatage rAF peut précéder t0
          draw(v, F, k * TOTAL);
          if (k < 1) v.raf = requestAnimationFrame(tick);
        };
        v.raf = requestAnimationFrame(tick);
      });
    },
    still: function (el) { this.play(el, { duration: 0 }); }
  };
})();
